import { Avatar, Badge, Breadcrumb, Button, Card, Col, Divider, Drawer, Flex, Form, Input, Layout, message, Popconfirm, Row, Select, Steps, Table, Tag, theme, Typography, Upload, Spin, notification } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined, FileWordOutlined, AppstoreOutlined, UploadOutlined, InboxOutlined, FileTextOutlined } from '@ant-design/icons';
import React, { useEffect, useState, forwardRef, useImperativeHandle, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import RequestApproval from '../../../restAPI/RequestApproval';

const { Search, TextArea } = Input;
const { Option } = Select;
const { Dragger } = Upload;
const { Text } = Typography;

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={[{ required: true, message: `${title} is required.` }]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingInlineEnd: 24 }}
        onDoubleClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const SupportDocs = forwardRef(({ setData, savedData, cerculateId }, ref) => {
  const { companyId, token, userCompany, role } = useSelector(state => state.auth);
  const [open, setOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement: 'bottomLeft'
    });
  };


  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    setFileList([]);
  };

  useEffect(() => {
    setCurrentFiles(savedData);
  }, [savedData]);

  useEffect(() => {
    // setCurrentFiles(savedData);
    console.log(fileList, "file list dddddddddddddddddddddd")
  }, [fileList]);

  useImperativeHandle(ref, () => ({
    saveSuportDocs() {
      setData(currentFiles);
    }
  }));

  RequestApproval.testWithJWTandCID(companyId, token);

  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'name',
      key: 'docName',
      editable: true,
    },
    {
      title: 'Added',
      dataIndex: 'added',
      key: 'added',
      width: 200,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 120,
      render: (_, record) => (
        <Flex align='center' justify='center' gap={16}>
          <Button icon={<DeleteOutlined />} onClick={() => removeFile(record)} type='primary' danger size='small' />
        </Flex>
      ),
    },
  ];

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const enhancedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: (updatedRow) => handleSaveCell(record, updatedRow), // Pass original record too
      }),
    };
  });

  const props = {
    name: "file",
    multiple: true,
    beforeUpload(file, index) {
      // console.log(index,"upload on index qqqqqqqqqq")
      // console.log(file,"upload on dragger")
      let contstate = { ...count }
      for (let doc of index) {
        if (file.uid === doc.uid) {
          if (file.type !== "application/pdf") {
            // message.error("only PDF files are allowed.");
            openNotification('error', 'Error', `only PDF files are allowed.`, 'bottomLeft');


            return false;
          }
          let date = new Date().toISOString().split('T')[0];
          const obj = {
            key: contstate,
            name: file.name,
            file: file,
            added: date
          };
          setFileList((prev) => [...prev, obj]);
          contstate = contstate + 1;
          // message.success(`${file.name} added to the list.`);
          openNotification('success', 'Success', `${file.name} added to the list.`, 'bottomLeft');

        }

      }
      setCount(contstate);
      return false;
    },
    onRemove(file) {
      console.log(file, "remove on dragger")

      setFileList((prev) => prev.filter((item) => item.key !== file.key));
      setCount(count - 1);
      // message.info(`${file.name} removed.`);
      openNotification('success', 'Success', `${file.name} removed.`, 'bottomLeft');
    },
    onDrop(e) {
      // console.log("Dropped files:", e.dataTransfer.files);
    },
  };

  const handleSaveCell = async (originalRecord, updatedRow) => {
    try {
      const obj = {
        approvalRequestId: cerculateId,
        originalFileName: originalRecord.name, // Original name before editing
        updatedFileName: updatedRow.name       // New name after editing
      };
      // console.log('Rename request:', obj); // Debug log
      const data = await RequestApproval.renameSuportDocuments(obj);
      if (data.status === "success") {
        setCurrentFiles((prev) =>
          prev.map((item) =>
            item.id === originalRecord.id ? { ...item, name: updatedRow.name } : item
          )
        );
        // message.success('File name updated successfully');
        openNotification('success', 'Success', `File name updated successfully`, 'bottomLeft');

      }
    } catch (err) {
      // console.error('Rename error:', err);
      // message.error(err.response?.data.message || 'Rename File Failed!');
      openNotification('error', 'Error', err.response?.data.message || 'Remove File Failed!', 'bottomLeft');
    }
  };

  const removeFile = async (file) => {
    try {
      const data = await RequestApproval.removeSuportDocuments(cerculateId, file.id);
      if (data.status === "success") {
        setCurrentFiles((prev) => prev.filter((item) => item.id !== file.id));
        setCount(count - 1);
        openNotification('info', 'Info', `${file.name} removed.`, 'bottomLeft');
      }
    } catch (err) {
      openNotification('error', 'Error', err.response?.data.message || 'Remove File Failed!', 'bottomLeft');
    }
};

  const uploadFiles = async () => {
    try {
      if (fileList.length > 0) {
        setLoading(true);
        const formData = new FormData();
        for (let i = 0; i < fileList.length; i++) {
          formData.append("files", fileList[i].file);
        }
        formData.append("approvalRequestId", cerculateId);
        const data = await RequestApproval.saveSuportDocuments(formData);

        const currentDocuments = data.data.approvalRequest.documents.map((item, index) => ({
          key: index,
          name: item.name,
          path: item.path,
          id: item._id,
          added: new Date().toISOString().split('T')[0]
        }));

        setCurrentFiles(currentDocuments);
        setFileList([]);
        setLoading(false);
        openNotification('success', 'Success', `Files added to the list.`, 'bottomLeft');

        onClose();
      } else {
        // message.error('Please Add New Files!');
        openNotification('error', 'Error', `Please Add New Files!`, 'bottomLeft');

      }
    } catch (err) {
      // message.error(err.response?.data.message || 'Upload File Failed!');
      openNotification('error', 'Error', err.response?.data.message || 'Upload File Failed!', 'bottomLeft');

    }
  };

  const handleRowClick = (record, columnName) => {
    if (columnName !== 2) {
      if (record?.path) {
        window.open(record.path, '_blank');
      }
    }
  }

  return (
    <>
      {contextHolder}
      <Card
        bordered={false}
        title="Support Documents"
        extra={<Button type='primary' icon={<UploadOutlined />} onClick={showDrawer}>Add Documents</Button>}
      >
        <Table
          components={components}
          // rowClassName={() => 'editable-row'}
          dataSource={currentFiles}
          columns={enhancedColumns}
          onRow={(record) => ({
            onClick: (e) => {
              const cell = e.target.closest('td');
              handleRowClick(record, cell.cellIndex);
            }
          })}
          // rowClassName="clickable-row" // Optional: Add custom styling for clickable rows
          style={{
            cursor: 'pointer', // Ensures rows appear clickable
          }}

        />
      </Card>
      <Drawer
        title="Add Support Documents"
        //onClose={onClose}
        open={open}
        onClose={() => !loading && onClose()} // Prevent closing when loading
        maskClosable={!loading} // Disable mask click when loading
        closable={!loading} // Disable close button when loading
        footer={[
          <Flex justify='flex-end' align='center' gap='large' key="footer">
            <Button onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button type='primary' onClick={uploadFiles} loading={loading} disabled={loading}>
              Upload
            </Button>
          </Flex>
        ]}
      >
        <Form layout='vertical'>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label=''>
                <Dragger {...props} fileList={fileList}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">
                    Support for a single upload. Strictly prohibited from uploading company data or other banned files.
                  </p>
                </Dragger>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
});

export default SupportDocs;